module.exports = __webpack_public_path__ + "static/media/imagenet5.19eb40ec.png";